import { render, staticRenderFns } from "./productdetail.vue?vue&type=template&id=fc23020a&scoped=true"
import script from "./productdetail.vue?vue&type=script&lang=js"
export * from "./productdetail.vue?vue&type=script&lang=js"
import style0 from "./productdetail.vue?vue&type=style&index=0&id=fc23020a&prod&lang=scss"
import style1 from "./productdetail.vue?vue&type=style&index=1&id=fc23020a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc23020a",
  null
  
)

export default component.exports